import { ref } from "vue";
import AppSettings from "@/settings/appSettings";
import historyJson from "../settings/buildHistory.json";

const lastSeenVersionKey = "ERA_LastSeenVersion";

function parseVersion(v: string) {
  return v.split('.').map(n => parseInt(n, 10));
}

function isVersionGreater(v1: string, v2: string) {
  const a = parseVersion(v1);
  const b = parseVersion(v2);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const n1 = a[i] || 0;
    const n2 = b[i] || 0;
    if (n1 > n2) return true;
    if (n1 < n2) return false;
  }
  return false;
}

export function useChangelog() {
  const changelog = ref(historyJson);
  const newUpdates = ref<typeof changelog.value>([]);
  const hasNewUpdates = ref(false);

  const lastSeen = localStorage.getItem(lastSeenVersionKey);
  const currentVersion = AppSettings.APP_Version;

  if (!lastSeen || isVersionGreater(currentVersion, lastSeen)) {
    newUpdates.value = changelog.value.filter(e =>
      !lastSeen || isVersionGreater(e.version, lastSeen)
    );
    hasNewUpdates.value = newUpdates.value.length > 0;
  }

  function markAsSeen() {
    localStorage.setItem(lastSeenVersionKey, currentVersion);
    hasNewUpdates.value = false;
  }

  return { changelog, newUpdates, hasNewUpdates, markAsSeen };
}
